/* @ngInject */
export default class MobileService {
  constructor(private deviceDetector) {}

  public isAndroid(): boolean {
    return this.deviceDetector.device.match(/android/i) !== null;
  }

  public isIOS(): boolean {
    return this.deviceDetector.device.match(/(ipad|iphone|ipod)/gi) !== null;
  }

  public isMobile(): boolean {
    return this.deviceDetector.isMobile();
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/mobile.service.ts